import axios from "axios";

//https://api.borgoolistico.com/
//https://apiborgoolistico.amark.pro/
let urlAPI = "https://api.borgoolistico.com/";
let axiosInstance = axios.create({
  baseURL: urlAPI,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
  },
});

export { urlAPI, axiosInstance };
